module.exports = __webpack_public_path__ + "img/Light-theme.6bc22a7a.png";